import Vue, { PropType } from 'vue';
import { TriviaQuestion } from '@/types';

export default Vue.extend({
	props: {
		trivia: Object as PropType<TriviaQuestion>
	}
});
